import { LOGIN_AUTH, VERIFY_EMAIL_RESET } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface LoginState extends BaseAsyncReducerState {
    success: boolean;
    token?: string;
    tip?: string;
    tip2?: boolean;
    refresh?: string,
    user_profile_id?: string;
    captcha: boolean | null;
    verified?: boolean;
    exp?: number;
    reset_req?: boolean | null;
    suspended?: boolean;
    show_survey?: boolean;
    is_agent?: boolean;
}

const initialState: LoginState = {
    tip: "",
    tip2: false,
    token: "",
    loading: false,
    error: false,
    success: false,
    captcha: null,
    user_profile_id: undefined,
    reset_req: false
}
  

function authLoginReducer(state = initialState, action: AppAction): LoginState | BaseAsyncReducerState | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case LOGIN_AUTH.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case LOGIN_AUTH.SUCCESS:

            return {
                ...state,
                ...payload,
                loading: false,
                error: false,

            }

        case LOGIN_AUTH.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };
        
        case VERIFY_EMAIL_RESET:
            return {
                ...state,
                ...initialState
            }

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}



export default authLoginReducer;